import { Button } from '@cimpress/react-components';
import React from 'react';
import { useModal } from '../../../contexts/modal-context';
import { Features } from '../../../models/features';
import { ShipmentGroup } from '../../../models/shipment-group';
import { Shipment } from '../../../ports/ShipmentsService';
import { useFeature } from '../../../store/hooks/useFeature';
import { FlexBox, FlexDirection, JustifyContent } from '../../../utils/css-classes';
import { VoidShipmentsModal } from '../../shipments/VoidShipmentsModal';
import { ShipmentsTable } from '../../ShipmentsTable';
import { Columns } from '../../ShipmentsTable/InternalShipmentsTable';
import { ShipmentGroupExplorerFilters } from './UnsortedShipmentsFilters';

// tslint:disable-next-line:import-name
import style from './index.module.css';

const tariffCategories: Record<string, string | undefined> = {
  Undeclared: 'undeclared',
  'Declared - General': 'declared_normal',
  'Declared - US FDA': 'declared_fda',
};

function mapTariffCategory(tariffCategory: string) {
  return tariffCategories[tariffCategory];
}

export interface UnsortedShipmentModalProps {
  shipmentGroup: ShipmentGroup;
}

// tslint:disable-next-line:function-name
function UnsortedShipmentSelectionComponent(
  {
    selection,
    clearSelection,
  }: {
    selection: Shipment[];
    clearSelection: () => void;
  },
) {
  const modal = useModal();

  if (!selection.length) {
    return <></>;
  }

  return <div className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${JustifyContent.FLEX_END} ${style.Selection}`}>
    <h5>{selection.length} shipment(s) selected</h5>
    <Button
      onClick={() => modal(
        <span>Void shipments selection</span>,
        hide => <VoidShipmentsModal shipments={selection} hide={hide} />,
      )}
    >
      Void Selection
    </Button>&nbsp;
    <Button onClick={clearSelection} type="primary">Clear Selection</Button>
  </div>;
}

// tslint:disable-next-line:function-name
export function UnsortedShipmentModal(
  { shipmentGroup }: UnsortedShipmentModalProps,
) {
  const {
    isLoading,
    value,
  } = useFeature(Features.WORKFLOWS);
  const shipmentSelectionComponent = !isLoading && value ? UnsortedShipmentSelectionComponent : undefined;
  const tariffCategory = shipmentGroup.tag ? mapTariffCategory(shipmentGroup.tag) : undefined;
  return <>
    <ShipmentsTable
      carrierAccountKeys={shipmentGroup.internalShipmentGroups.map(({ key }) => key)}
      isVoided={false}
      isSorted={false}
      initialSort={[['createdAt', 'DESC']]}
      tags={tariffCategory ? [tariffCategory] : undefined}
      hideColumns={[Columns.SORTED_AT, Columns.MANIFESTED_AT, Columns.CARRIER_ACCOUNT_KEY, Columns.STATUS]}
      FiltersComponent={ShipmentGroupExplorerFilters}
      SelectionComponent={shipmentSelectionComponent}
    />
  </>;
}
